import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { xmlns: "http://www.w3.org/2000/svg" }

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1))
}
export default { render };